module.exports = __webpack_public_path__ + "static/media/img_23.f80eef48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_23.jpg
// module id = 542
// module chunks = 0